import { render } from "./Title.vue?vue&type=template&id=739549a8&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=739549a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-739549a8"

export default script